const logStatusColors = {
  dispatched: "darkGrey",
  swapModelRequested: "darkGrey",
  inProgress: "orangeBtnColor",
  completed: "green",
  inError: "red",
  cancellationRequested: "orangeBtnColor",
  cancelled: "red",
  swapping: "orangeBtnColor",
  swapModelFailed: "red",
};
const mapBackgroundColorWithAgentTypeAndMode = (agent, currentTheme) => {
  const _mode = agent.mode;

  switch (_mode) {
    case "retriever":
      return currentTheme?.theme?.primary;
    case "chatter":
      return currentTheme?.theme?.green;
    case "coder":
      return currentTheme?.theme?.orange;
    case "voice":
      return currentTheme?.theme?.purple;
    default:
      return currentTheme?.theme?.primary;
  }
};

// Model-size tiers (Workspace.blockedModels picker, QA model dropdowns).
// Hardcoded hex (NOT theme values): the chip styles go through Utility/Color,
// which only parses hex — theme colors are rgba() strings and would NaN out.
const MODEL_SIZE_COLORS = {
  extraSmall: "#5D94D6", // light_blue
  small: "#5486C4", // text_blue
  medium: "#1DB7C5", // primary
  large: "#DF8243", // orange
  extraLarge: "#7441A7", // purple
  ultra: "#28C552", // green
};

const mapBackgroundColorWithModelSize = (model, currentTheme) => {
  const tier = model?.modelType;
  return MODEL_SIZE_COLORS[tier] || MODEL_SIZE_COLORS.medium; // default = primary
};

export default {
  logStatusColors,
  mapBackgroundColorWithAgentTypeAndMode,
  mapBackgroundColorWithModelSize,
};
